import { useEffect, useState } from 'react';
import { StanInput, StanModal } from '@/components';
import type { SectionItem } from '../types/myStore.types';

export interface EditSectionModalProps {
    isOpen: boolean;
    section: SectionItem | null;
    isLoading?: boolean;
    onConfirm: (sectionId: number, newTitle: string) => void;
    onCancel: () => void;
}

export function EditSectionModal({ isOpen, section, isLoading = false, onConfirm, onCancel }: EditSectionModalProps) {
    const [title, setTitle] = useState('');

    useEffect(() => {
        if (isOpen && section) {
            setTitle(section.title);
        }
    }, [isOpen, section]);

    const handleConfirm = () => {
        if (section && title.trim() && !isLoading) {
            onConfirm(section.section_id, title.trim());
        }
    };

    const handleCancel = () => {
        onCancel();
    };

    return (
        <StanModal
            id='edit-section-modal'
            isOpen={isOpen}
            onClose={handleCancel}
            title='Edit Section'
            primaryActionDisabled={!title.trim() || isLoading}
            primaryActionLoading={isLoading}
            primaryActionLabel='Save'
            onPrimaryAction={handleConfirm}
            size='sm'
            secondaryActionDisabled={isLoading}
            secondaryActionLabel='Cancel'
            onSecondaryAction={handleCancel}
        >
            <div className='flex flex-col gap-4'>
                <StanInput
                    name='Section Title'
                    value={title}
                    onChange={e => setTitle(e.target.value)}
                    placeholder='Enter section title'
                    autoFocus
                    onKeyDown={e => {
                        if (e.key === 'Enter') {
                            handleConfirm();
                        }
                    }}
                />
            </div>
        </StanModal>
    );
}
